/**
 * top-nav.js
 *
 * Marks the current page's link in the shared top-nav pill (sections/top-nav.html)
 * so the include can be reused verbatim across pages. Highlights by URL rather
 * than a hard-coded `aria-current`, then applies the brand underline + active
 * color to the matching link (and clears the others).
 */

const path = window.location.pathname;

document.querySelectorAll('.top-nav-pill nav a[href]').forEach((link) => {
  const href = link.getAttribute('href');
  // Home ("/") matches only the exact root; other links match by prefix so
  // e.g. /blog/, /blog/<slug>/ all light up "Blogs".
  const isCurrent = href === '/' ? path === '/' : path.startsWith(href);

  link.classList.toggle('link--underline--brand', isCurrent);
  link.classList.toggle('text-slate-900', isCurrent);
  link.classList.toggle('link--underline--dark', !isCurrent);
  link.classList.toggle('hover:text-slate-900', !isCurrent);

  if (isCurrent) link.setAttribute('aria-current', 'page');
  else link.removeAttribute('aria-current');
});
